import { Configuration } from "./api/axios-client";
import axios from 'axios';
import { beginGlobalLoading } from '../Data/LoadingManager';

type ApiServiceConstructor<T> = new (configuration: Configuration) => T;

const getAuthToken = (): string | null => {
  let authToken = localStorage.getItem('authToken');
  if (authToken) {
    const jAuthToken = JSON.parse(authToken) as any
    if (jAuthToken['accessToken']) {
      return jAuthToken['accessToken']
    } else {
      return null
    }
  }
  return null

}
const getCustomHeaders = (): string => {
  // Extract subdomain from current URL
  const hostname = window.location.hostname;
  const subdomain = hostname.split('.')[0];
  return subdomain;
}
export const checkExpiration = (token: string): boolean => {
  const payload = JSON.parse(atob(token.split('.')[1]));
  const expirationTime = payload.exp * 1000;
  const isExpired = Date.now() > expirationTime;
  return isExpired;

};

export const axiosClient = axios.create({
      baseURL: import.meta.env.VITE_SPOT_SYNC_SERVICES,
  headers: {
    'Content-Type': 'application/json',
    'X-Customer-Subdomain': getCustomHeaders(),
  },
});

axiosClient.interceptors.request.use((config) => {
  const hasToken = config.params?.hasToken ?? true
  const token = getAuthToken();
  // Begin global loading for any axios request
  const end = beginGlobalLoading();
  (config as any).__loadingEnd = end;
  if (token != null && hasToken) {
        const isExpired = checkExpiration(token);
        if (isExpired) {
          const source = axios.CancelToken.source();
          localStorage.removeItem('authToken');
          window.location.href = '/login';
          config.cancelToken = source.token;
          source.cancel('Token expired, redirecting to sign-in');
          return config;
        }
  }

  if (token && hasToken) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    (response.config as any)?.__loadingEnd?.();
    return response;
  },
  (error) => {
    try {
      error?.config && (error.config as any).__loadingEnd?.();
    } catch {}
    return Promise.reject(error);
  }
);

export const createApiService = <T>(ApiClass: ApiServiceConstructor<T>): T => {
  const apiClient: any = new ApiClass(
    new Configuration({
              basePath: import.meta.env.VITE_SPOT_SYNC_SERVICES,
    }));
  apiClient['axios'] = axiosClient;
  return apiClient;
};
